import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type DocusignIconProps = IconProps;

export const DocusignIcon: FC<DocusignIconProps> = ({ className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.4037 14.3935V19.5045C14.4037 19.773 14.1869 19.9898 13.9184 19.9898H0.485287C0.21683 19.9898 0 19.773 0 19.5045V6.08172C0 5.81327 0.21683 5.59644 0.485287 5.59644H5.58596V13.9083C5.58596 14.1767 5.80279 14.3935 6.07124 14.3935H14.4037Z"
      fill="#4C00FF"
    />
    <path
      d="M19.9999 7.1864C19.9999 11.4817 17.4909 14.3831 14.4036 14.3934V8.98299C14.4036 8.82811 14.3417 8.67323 14.2281 8.56998L11.4196 5.76152C11.3061 5.64794 11.1615 5.58599 11.0066 5.58599H5.59619V0.485314C5.59619 0.216858 5.81302 2.75669e-05 6.08148 2.75669e-05H13.6499C17.2431 -0.0102977 19.9999 2.88077 19.9999 7.1864Z"
      fill="#FF5252"
    />
    <path
      d="M14.2281 8.55985C14.3417 8.67343 14.4036 8.81798 14.4036 8.97286V14.3833H6.08148C5.81302 14.3833 5.59619 14.1665 5.59619 13.898V5.58618H11.0066C11.1615 5.58618 11.3164 5.64813 11.4196 5.76171L14.2281 8.55985Z"
      fill="black"
    />
  </svg>
);
